<!-- No connectivity page-->
<div class="misc-wrapper">
  <div class="misc-inner p-2 p-sm-3">
    <div class="w-100 text-center">
      <h2 class="mb-1">{{'NO_CONNECTIVITY_TITLE' | translate}} 📡</h2>
      <p class="mb-2">{{'NO_CONNECTIVITY_MESSAGE' | translate}}</p>
      <p class="mb-3">{{'NO_CONNECTIVITY_UPDATE_MESSAGE' | translate}}</p>
      <img class="img-fluid"
        [src]="coreConfig.layout.skin === 'dark' ? 'assets/images/pages/error-dark.svg' : 'assets/images/pages/error.svg'" alt="No connectivity" />
    </div>
  </div>
</div>
<!-- / No connectivity page-->
